/* !
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

(function(window, undefined) {
  '$:nomunge'; // Used by YUI compressor.

  /* Since jQuery really isn't required for this plugin, use `jQuery` as the
     Namespace only if it already exists, otherwise use the `Cowboy` namespace,
     Creating it if necessary. */
  var $ = window.jQuery || window.Cowboy || (window.Cowboy = {}),

      // Internal method reference.
      jq_throttle;

  $.throttle = jq_throttle = function(delay, no_trailing, callback, debounce_mode) {
    /* After wrapper has stopped being called, this timeout ensures that
       `callback` is executed at the proper times in `throttle` and `end`
       Debounce modes. */
    var timeout_id,

        // Keep track of the last time `callback` was executed.
        last_exec = 0;

    // `no_trailing` defaults to falsy.
    if (typeof no_trailing !== 'boolean') {
      debounce_mode = callback;
      callback = no_trailing;
      no_trailing = undefined;
    }

    /* The `wrapper` function encapsulates all of the throttling / debouncing
       Functionality and when executed will limit the rate at which `callback`
       Is executed. */
    function wrapper() {
      var that = this,
          elapsed = Number(new Date()) - last_exec,
          args = arguments;

      // Execute `callback` and update the `last_exec` timestamp.
      function exec() {
        last_exec = Number(new Date());
        callback.apply(that, args);
      }


      /* If `debounce_mode` is true (at_begin) this is used to clear the flag
         To allow future `callback` executions. */
      function clear() {
        timeout_id = undefined;
      }


      if (debounce_mode && !timeout_id) {
        /* Since `wrapper` is being called for the first time and
           `debounce_mode` is true (at_begin), execute `callback`. */
        exec();
      }

      // Clear any existing timeout.
      timeout_id && clearTimeout(timeout_id);

      if (debounce_mode === undefined && elapsed > delay) {
        /* In throttle mode, if `delay` time has been exceeded, execute
           `callback`. */
        exec();
      } else if (no_trailing !== true) {
        /* In trailing throttle mode, since `delay` time has not been
           Exceeded, schedule `callback` to execute `delay` ms after most
           Recent execution.
           If `debounce_mode` is true (at_begin), schedule `clear` to execute
           After `delay` ms.
           If `debounce_mode` is false (at end), schedule `callback` to
           Execute after `delay` ms. */
        timeout_id = setTimeout(debounce_mode ? clear : exec, debounce_mode === undefined ? delay - elapsed : delay);
      }
    }


    /* Set the guid of `wrapper` function to the same of original callback, so
       It can be removed in jQuery 1.4+ .unbind or .die by using the original
       Callback as a reference. */
    if ($.guid) {
      wrapper.guid = callback.guid = callback.guid || $.guid++;
    }

    // Return the wrapper function.
    return wrapper;
  };

  $.debounce = function(delay, at_begin, callback) {
    return callback === undefined
      ? jq_throttle(delay, at_begin, false)
      : jq_throttle(delay, callback, at_begin !== false);
  };
})(this);
